export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: 2900,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      backgroundImage: 'none !important',
      backgroundColor: theme.palette.yellow.main,
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  title: {
    zIndex: 2,
    position: 'absolute',
    top: '0%',
    left: 23,
    width: 600,
    color: theme.palette.white.main,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      textAlign: 'center',
      padding: theme.spacing(4),
      color: theme.palette.blue.dark,
      width: '80%',
      transform: 'initial',
      margin: `0 auto ${theme.spacing(2)}px auto`,
    },
  },
  subtitle: {
    zIndex: 2,
    position: 'absolute',
    bottom: 100,
    left: 55,
    width: 500,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.white.main,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      padding: theme.spacing(2),
      color: theme.palette.primary.main,
      width: '80%',
      transform: 'initial',
      margin: `${theme.spacing(2)}px auto ${theme.spacing(2)}px auto`,
    },
  },
  content: {
    position: 'relative',
    height: '100%',
    zIndex: 5,
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  card1: {
    position: 'absolute',
    top: 0,
    left: 1100,
    transform: 'translateX(-50%)',
  },
  card2: {
    position: 'absolute',
    top: '50vh',
    left: 700,
  },
  card3: {
    position: 'absolute',
    top: '50vh',
    left: 1400,
  },
  card4: {
    position: 'absolute',
    top: '45vh',
    left: 1760,
    transform: 'translateY(-100%)',
  },
  card5: {
    position: 'absolute',
    bottom: 56,
    left: 2125,
  },
  cardMobile: {
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      margin: `${theme.spacing(2)}px auto ${theme.spacing(2)}px auto`,
      transform: 'initial',
      textAlign: 'center',
    },
  },
});
